'use strict';

import React, { Component } from 'react';
import ValidationOverlay from '../validationOverlay.jsx';
import { Button, ListItem, ListItemIcon, ListItemText, Typography, Box ,TextField} from '@material-ui/core';
import { Settings } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { InputSelect } from '../../../commonModules/interface/form-input-inline.jsx';
import Dialog from '../../../commonModules/interface/Dialog.jsx';
var $ = require('jquery');

class ChangeSubscription extends Component{
    emptyTable = [{id: "", idobj: "none", needProductID: "",status:"",stocklink:""}]
    state = {
        subList: false,

        subscriptionlistValue: "",
        subscriptionlist: this.emptyTable,
        errmsg: '',
        msg: '',
        url: '',
        popupStateValidation: false
    }
    componentDidMount = async () => {
        //Get Subscrption List
        var methodName = "componentDidMount / ChangeSubscription"
        var urlSubscription = "/subscription/list";
        this.serverRequestSubscription = $.get(urlSubscription, function (result) {
            console.log('[INFO],  reception des données des subscription de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.contentJs.length; i += 1) {
                    optionTmp.push({id: data.contentJs[i].name, idobj: data.contentJs[i].id,needProductID: data.contentJs[i].needProductID, status:data.contentJs[i].other.status,stocklink: data.contentJs[i].stocklink})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({subscriptionlist: optionTmp, subscriptionlistValue: ""});
        }.bind(this));
    }
    handleSubmit = async (e) => {
        console.log('Change Subscription request for ', this.props.boxId, ' or ', this.props.userId);
        //Open a windows to choose Subscription Demande de confirmation
        var subscriptionId = "";
        for (var i = 0; i < this.state.subscriptionlist.length; i += 1) {
            if (this.state.subscriptionlist[i].id === this.state.subscriptionlistValue) {
                subscriptionId = this.state.subscriptionlist[i].idobj;
            }
        }
        if (subscriptionId === '') {
            this.setState({errmsg: "Type d'abonnement Id can not be empty. Reload Page"});
            return;
        }
        var url = "/subscription/change?boxAssoId=" + this.props.boxAssoId + "&userId=" + this.props.userId + "&subscription=" + subscriptionId;
        var msg = "Changement abonnement du sytème pour le Contrat : " + this.state.subscriptionlistValue;
        //Active Pop up Security
        this.setState({popupStateValidation: true , msg: msg, url: url});

    }
    cancelSubmit = async () => {
        console.log('Cancel Change Subscription request for ', this.props.boxId, ' or ', this.props.userId);
        this.setState({subList: false});
    }
    requestSubmit = async () => {
        console.log('Request Change Subscription request for ', this.props.boxId, ' or ', this.props.userId);
        this.setState({subList: true});
    }
    onChangeSubscription = async (e) => {
        var value = e.value;
        this.setState({subscriptionlistValue: value});
    }
    onValidationSucceed = async () => {
        this.setState({subList: false, errmsg: 'Abonnement modifié', popupStateValidation: false});
    }
    onCancelation = async () => {
        this.setState({ popupStateValidation: false });
    }
    render () {
        const { subscriptionlist } = this.state;
        return (
            <MiniCard 
                title="Abonnement"
                avatar={<Settings />}
            >
                {!this.state.subList && 
                    <Box p={1}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.requestSubmit}
                        >
                            Changement Abonnement
                        </Button>
                    </Box>
                }
                
                {this.state.subList &&
                    <Dialog
                        block={true}
                        title="Changer Abonnement"
                        submitAction={this.handleSubmit}
                        close={this.cancelSubmit}
                    >
                        <InputSelect
                            value={this.state.subscriptionlistValue}
                            onChange={this.onChangeSubscription}
                            options={subscriptionlist.map( optionval => (  
                                {value: optionval.id, label:optionval.id,disabled: optionval.status === "Disabled" , title:optionval.id}
                                ))
                            }
                        />
                    </Dialog>
                }
                
                {this.state.errmsg}
                {this.state.popupStateValidation &&
                    <ValidationOverlay
                        msg={this.state.msg}
                        popupStateButton={this.state.popupStateValidation}
                        url={this.state.url}
                        onValidation={this.onValidationSucceed}
                        onCancelation={this.onCancelation}
                    />
                }
                {/* {this.state.popupStateValidation &&
                    <ValidationOverlay
                        msg={this.state.msg}
                        popupStateButton={this.state.popupStateValidation}
                        url={this.state.url}
                        onValidation={this.onValidationSucceed}
                        onCancelation={this.onCancelation}
                    />
                } */}
                 {/* <TextField
                    style={{width:"100%"}}
                    variant="outlined"  
                    label="Rechercher" 
                    // margin="normal"
                    // value={this.props.search} 
                /> */}

            </MiniCard>
        )
    }
};
export default ChangeSubscription